
import { Template, TemplateSchema } from './SpotSchema';
import { useEffect, useRef, useState } from 'react';
import { EditableSvg } from "../ui/svg";
import { useApiFetch } from '@/helper/apiFetch';
import { useTranslate } from '@/helper/translate';
import React from 'react';
type TemplateProps = {
  templateId: string;
  customerId: string;
  statusId: number;
  //aspectRatio: string;
  onChanged: () => void;
};

export type TemplateHandle = { Save: () =>  Promise<string>  };

const SVGEditor = React.forwardRef<TemplateHandle, TemplateProps>(
  ({ templateId, customerId, statusId, onChanged }, ref) => {


//export function TemplateEditor({ templateId, customerId,format,  onClose }: TemplateProps) {

  const apiFetch = useApiFetch();
const { translate } = useTranslate();
  
  const [isLoaded, setIsLoaded] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [pageIndex, setIndex] = useState(0);
  //const [formatIndex, setFormat] = useState(0);
  const [template, setTemplate] = useState<Template>();
  //const fileMapRef = useRef(new Map<string, Blob>());



 





//return string 
const Save = async (): Promise<string> => {
   
    try {
      setIsGenerating(true);
      // setError("");
// const payload = {
//   template,
//   customerId: customerId
// };



      const res = await apiFetch(`/App/SaveTemplate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(template),
      });





      if (!res.ok) {
        setIsGenerating(false);
        const e = await res.text();
        
        return "error" + e;

      }
      else {
        const data = await res.json();
        return data as string;


      }
    } catch (err) {
      console.error(err);
    }

    return "";
  }

 React.useImperativeHandle(ref, () => ({ Save }), [Save]);

  useEffect(() => {




    apiFetch(`/App/GetTemplate?templateId=${templateId}`)
      .then(res => {
        if (!res.ok) throw new Error("Failed to fetch");
        return res.json();
      })
      .then(data => {
          

        if (data.template_TemplateId == null || data.template_TemplateId === '') {
          //new from template, create a template copy
          console.log("Creating new template from existing ", data.templateId);
          data.template_TemplateId = data.templateId;
          data.templateId = null;
          data.templateFormats.forEach(s=>s.templateId=null);
        }
          data.customerId = customerId;

        setTemplate(data);
        setIsLoaded(true);
      })
      .catch(err => {
        console.error(err);

      });
  }, []);

  //   useEffect(() => {

  //     if (!template) return;

  //     const index = template.templateFormats.findIndex(f => f.aspectRatio === aspectRatio);
     
  //       setFormat(index);
      
  // }, [template, aspectRatio]);


  return (

    <div className="popCnt p-0">
      {!isLoaded ? (
        <div className="w-full text-center my-10">{translate("common.loading")}</div>
      ) : (


       



              <div className="!mt-0">


{/* {formatIndex > 0 ? ( */}
  <div>
                <div className="tabs !border-none">
                  {Array.from({ length: template?.numberOfPages??1 }).flatMap((_, index) => (
                    <span
                      key={index}
                      className={`tab ${template?.numberOfPages === 1 ? 'hidden' : ''} ${index === pageIndex ? 'active' : ''}`}
                      onClick={() => setIndex(index)}
                    >
                        {translate("ui.page")}  {index + 1}
                    </span>
                  ))}
                </div>




               
                    <EditableSvg
                      template={template as Template}
                      statusId={statusId}
                      className="origin-top-left scale-[.8]"
                      pageNumber={pageIndex}
                      //formatIndex={formatIndex}
                      // onChange={(svg)=>{ 
                      //   console.log('templatechanged',template?.templateFormats[0].html); 
                      //   /*template?.templateFormats[formatIndex].html = svg; template?.isGenerated =false;*/
                      // }}
                    //style={{ maxHeight: "50vh", aspectRatio :format.replace("x","/") }
                    //onChange={(svg) => form.setValue(`html`, svg)}
                    />

                  

               
                </div>
{/* ): <div>This template does not support {aspectRatio}</div>} */}
                

{/* <div>
                  {template?.templateFormats?.map((f, index) => (
                    <button
                      key={f.templateFormatId}
                      className={`btn ${index === formatIndex ? 'btn-primary' : 'btn-secondary'} m-1`}
                      onClick={() => { setFormat(index); }}
                    >
                      {f.aspectRatio || "Unknown"}
                    </button>
                  ))}
                </div> */}
              </div>
      



            
                )}





    </div>

              )

}

);

export { SVGEditor };

